import { Task, TaskStatus } from '../../types';

type GameTasksResponse = { tasks?: any[] } | any[];

const mapGameStatusToTaskStatus = (
  status: TaskStatus | string | undefined | null,
): TaskStatus => {
  switch (status) {
    case 'NOT_STARTED':
    case 'IN_PROGRESS':
    case 'DONE':
    case 'CLAIMED':
    case 'CHECK':
    case 'SLEEP':
      return status;
    case 'active':
    case 'not_started':
    case 'new':
      return 'NOT_STARTED';
    case 'waiting':
    case 'in_progress':
      return 'IN_PROGRESS';
    case 'check':
      return 'CHECK';
    case 'claim':
      return 'DONE';
    case 'done':
    case 'claimed':
      return 'CLAIMED';
    default:
      return 'NOT_STARTED';
  }
};

const getButtonText = (status: TaskStatus): string => {
  switch (status) {
    case 'CLAIMED':
      return 'Завершено';
    case 'DONE':
      return 'Собрать';
    case 'CHECK':
      return 'Проверить';
    case 'IN_PROGRESS':
      return 'Проверка';
    case 'NOT_STARTED':
    default:
      return 'Выполнить';
  }
};

export class GameTasksAdapter {
  static adaptTasks(response: GameTasksResponse): Task[] {
    const tasks = Array.isArray(response)
      ? response
      : Array.isArray((response as any)?.tasks)
        ? (response as any).tasks
        : [];

    if (!Array.isArray(tasks)) {
      console.warn('❌ GameTasksAdapter: invalid response format', response);
      return [];
    }

    return tasks.map((raw) => {
      const title =
        raw?.view_details?.title ||
        raw?.title ||
        raw?.name ||
        'Игровое задание';
      const description =
        raw?.description || raw?.details?.description || '';
      const link = raw?.view_details?.link || raw?.link || '';
      const stars =
        raw?.rewards?.stars ?? raw?.reward_amount ?? raw?.stars ?? 0;
      const status = mapGameStatusToTaskStatus(raw?.status);
      const progress =
        raw?.target_progress != null && raw?.user_progress != null
          ? { current: raw.user_progress, total: raw.target_progress }
          : undefined;
      const id =
        raw?.id ??
        raw?.task_id ??
        raw?.ad_id ??
        raw?.view_details?.id ??
        title;

      return {
        id,
        title,
        description,
        rewards: { stars },
        status,
        progress,
        link,
        provider: 'GAME_TASKS',
        type: 'sponsors',
        buttonText: raw?.button_text || getButtonText(status),
        visibility: raw?.visibility ?? true,
        icon: raw?.details?.photo || raw?.icon,
        instructions: raw?.details?.task_instructions,
      } as Task;
    });
  }
}








